import React from 'react';
import PropTypes from 'prop-types';
import { formatDateTime, transformFeedback } from 'utils/Formatters';

const AccountPlayerFreePlaysRow = ({ data }) => {
  return (
    <tr>
      <td>{data.playType}</td>
      <td>{data.domain}</td>
      <td>{formatDateTime(data.createdAt)}</td>
      <td>{data.enteredText}</td>
    </tr>
  );
}

AccountPlayerFreePlaysRow.propTypes = {
  data: PropTypes.object.isRequired,
};

export default AccountPlayerFreePlaysRow;
